<div class="scrollbar" id="style-1">
  <h5 class="my-3 ml-3">Notifications
    <span class="float-right mr-4">
      <button 
        (click)="fetchAllNotification()"
        [disabled]="viewAllFlag"
        [ngStyle]="{'color': viewAllFlag ? 'var(--Main, #adb5bd)' : 'var(--Main, #3D5CFF)',
                    'cursor': viewAllFlag ? 'default' : 'pointer'}"
        style="font-size: 13px; background:none; border:none;">
        View All
      </button>
    </span>
  </h5>

  <ul style="max-height: 80vh">
    <li *ngFor="let n of userNotification; trackBy: trackByNotification">
      <div class="flex">
        <div class="p-2">
          <p-avatar
            [icon]="n.icon"
            [style]="{ 'background-color': '#EAEAFF', color: '#3D5CFF' }"
            size="large"
            shape="circle"
          ></p-avatar>
        </div>

        <div class="align-items-center">
          <h6>{{ n.title }}</h6>
          <p class="m-0">{{ n.body }}
            <span *ngIf="n?.data?.download_url" class="pointer" style="font-size: 12px;font-weight:600">
            <a href="{{ n?.data?.download_url }}" target="_blank" [ngClass]="isOlderThanSevenDays(n?.added_on) ? 'disabled-link' : ''">[Download]</a>
          </span>
        </p>
        </div>
      </div>
    </li>
    <div *ngIf="pagination.count != 0">
        <div
          class="text-center pt-3"
          *ngIf="userNotification.length != pagination.count"
        >
          <small class="pointer text-primary" (click)="onScrollDown()"
            >See more</small
          >
        </div>
        <div class="text-center py-3">
          <small class="text-secondary">
            Showing {{userNotification.length}} of {{pagination.count}}
          </small>
        </div>
      </div>
  </ul>
</div>
